import contactImg from "../../images/contact-us-image.webp";

const ContactHero = () => {
  return (
    <div className="py-[100px] px-[30px] flex flex-col lg:flex-row items-start gap-10">
      <div className="w-[97%] lg:w-[55%]">
        <div className="bg-[#ffebbe] h-[30vh] lg:h-[75vh] w-[95%] rounded-[15px]">
          <img
            src={contactImg}
            alt=""
            className="h-[110%] lg:h-[105%] relative top-[-30px] lg:top-[-22px] left-16"
          />
        </div>
        <div className="flex flex-col lg:flex-row items-start justify-evenly gap-8 lg:gap-0 mt-[50px] py-[30px]">
          <div className="flex gap-4">
            <i className="fa-solid fa-location relative top-2"></i>
            <div className="w-[60%]">
              <h4 className="font-[600] text-[18px]">Address</h4>
              <p>8460 Rickville Ave, Greenville, NC 278834</p>
            </div>
          </div>
          <button className="border-[1px] border-slate-400 rounded-[5px] px-[10px] py-[8px] flex items-center gap-3 hover:bg-amber-500">
            <i class="fa-solid fa-route"></i>
            Get Directions
          </button>
        </div>
        <hr />
        <div className="flex flex-col lg:flex-row items-start justify-evenly py-[30px]">
          <div className="flex items-start gap-3 leading-8">
            <i className="fa-solid fa-phone relative top-2"></i>
            <div>
              <h4>Call Us Today</h4>
              <span>
                <b>Mobile:</b> +234 906 835 1922
              </span>
              <br />
              <span>
                <b>Email:</b> irediaerhabor75@gmail.com
              </span>
            </div>
          </div>
          <div className="flex items-start gap-3 leading-8">
            <i className="fa-solid fa-clock relative top-2"></i>
            <div>
              <h4>Opening Hours</h4>
              <span>
                <b>Mon-Fri:</b> 08:30-21:00
              </span>
              <br />
              <span>
                <b>Sat-Sun:</b> 10:00-19:00
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* form part */}
      <div className="w-[95%] lg:w-[55%]">
        <h2 className="text-[35px] font-[700] w-[95%] lg:w-[60%]">
          Have Questions? We’re Here for You!
        </h2>
        <p className="text-[18px] py-[10px]">
          Lorem ipsum dolor sit amet consectetur adipisicing elit.
        </p>
        <form className="flex flex-wrap pt-[30px]">
          <div className="w-[100%] lg:w-[50%] my-[10px]">
            <label htmlFor="firstname">First Name</label>
            <br />
            <input
              type="text"
              name="Firstname"
              id="firstname"
              placeholder="First Name"
              className="bg-[#f3f4f6] py-[15px] px-[15px] mt-[5px] rounded-[5px] w-[95%]"
            />
          </div>
          <div className="w-[100%] lg:w-[50%] my-[10px]">
            <label htmlFor="lastname">Last Name</label>
            <br />
            <input
              type="text"
              name="Lastname"
              id="lastname"
              placeholder="Last Name"
              className="bg-[#f3f4f6] py-[15px] px-[15px] mt-[5px] rounded-[5px] w-[95%]"
            />
          </div>
          <div className="w-[100%] my-[10px]">
            <label htmlFor="email">Email</label>
            <br />
            <input
              type="email"
              name="Email"
              id="email"
              placeholder="Email Address"
              className="bg-[#f3f4f6] py-[15px] px-[15px] mt-[5px] rounded-[5px] w-[97%]"
            />
          </div>
          <div className="w-[100%] my-[10px]">
            <label htmlFor="subject">Subject</label>
            <br />
            <input
              type="text"
              name="Subject"
              id="subject"
              placeholder="Subject"
              className="bg-[#f3f4f6] py-[15px] px-[15px] mt-[5px] rounded-[5px] w-[97%]"
            />
          </div>
          <div className="w-[100%] my-[10px]">
            <label htmlFor="message">Your Message</label>
            <br />
            <textarea
              name="Message"
              id="message"
              placeholder="Your Message"
              rows={10}
              className="bg-[#f3f4f6] py-[15px] px-[15px] mt-[5px] rounded-[5px] w-[97%]"
            ></textarea>
          </div>
          <input
            type="submit"
            value="Send Message"
            className="bg-black text-white py-[15px] px-[15px] rounded-[5px] mt-[10px] font-[600] hover:bg-amber-500 hover:text-black cursor-pointer"
          />
        </form>
      </div>
    </div>
  );
};

export default ContactHero;
